import React from "react";
import { graphql } from "gatsby";
import { getImage } from "~/helpers";
import SEO from "~/components/seo";
import { DeriveHeaderClasses } from "~/components/Navigation";
import { ProductGrid, CollectionPageFooter } from "~/components/CollectionPage";
import {
  HeadingLarge,
  Subheading,
  BodyText,
} from "~/components/.base/headings";
import Hero from "~/components/.base/hero";
import header_image from "~/images/collectionPage/default_collection_header.jpg";

import "./CollectionPage.scss";

const CollectionPage = ({ data }) => {
  console.log(data);
  const { title, handle, products } = data.shopifyCollection;
  const filteredProducts = products.filter(
    (p) => !p.title.includes("Subscription")
  );
  return (
    <div className="collection-page">
      <SEO title={title} />
      <DeriveHeaderClasses />
      <Hero
        wrapperClass="hero"
        image={header_image}
        imageFluid={getImage(
          data.collectionImages.edges,
          "default_collection_header"
        )}
        alt={title}
      >
        <div className="header-details">
          <Subheading color="#fff">Collection</Subheading>
          <HeadingLarge color="#fff">{title}</HeadingLarge>
          <BodyText color="#fff">
            Nam dapibus nisl vitae elit fringilla rutrum. Aenean sollicitudin,
            erat a elementum rutrum, neque sem pretium metus, quis mollis nisl
            nunc et massa.
          </BodyText>
        </div>
      </Hero>
      <ProductGrid bgImages={data.bgImages.edges} products={filteredProducts} />
      <CollectionPageFooter
        collectionImages={data.collectionImages.edges}
        collectionHandle={handle}
      />
    </div>
  );
};
export const query = graphql`
  query($handle: String!) {
    shopifyCollection(handle: { eq: $handle }) {
      id
      title
      handle
      description
      products {
        title
        images {
          originalSrc
          id
          localFile {
            childImageSharp {
              fluid(maxWidth: 910) {
                ...GatsbyImageSharpFluid_withWebp_tracedSVG
              }
            }
          }
        }
        handle
        variants {
          price
        }
      }
    }
    collectionImages: allFile(
      filter: {
        extension: { regex: "/(jpg)|(png)|(tif)|(tiff)|(webp)|(jpeg)/" }
        absolutePath: { regex: "/images/collection/" }
      }
    ) {
      edges {
        node {
          name
          childImageSharp {
            fluid(maxWidth: 1000, quality: 100) {
              aspectRatio
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    }
    bgImages: allFile(
      filter: {
        extension: { regex: "/(jpg)|(png)|(tif)|(tiff)|(webp)|(jpeg)/" }
        absolutePath: { regex: "/images/background/" }
      }
    ) {
      edges {
        node {
          name
          childImageSharp {
            fluid(maxWidth: 1000, quality: 100) {
              aspectRatio
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    }
  }
`;

export default CollectionPage;
